import {
  Box, useTheme,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import OptimusButton from '../../../../common/library/Button/Button';

export const PartnerHeader = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const fromTab = (location.state as { fromTab?: 'all-partners' | 'your-partners' })?.fromTab;

  const handleBackClick = () => {
    const targetPath = fromTab === 'your-partners' ? '/partners?tab=your-partners' : '/partners';
    navigate(targetPath);
  };

  return (
    <>
      <Box
        sx={{
          padding: `${theme.spacing(4)} ${theme.spacing(0)} ${theme.spacing(0)} ${theme.spacing(4)}`,
          [theme.breakpoints.down('md')]: {
            padding: `${theme.spacing(0)} ${theme.spacing(0)} ${theme.spacing(0)} ${theme.spacing(1)}`,
          },
        }}
      >
        <OptimusButton
          size={'m'}
          customVariant='secondaryGray'
          leadingIcon={ArrowBackIcon}
          type="button"
          width={'fit-content'}
          onClick={handleBackClick}
          buttonText={`${t('partnerDetails.backToAllRewards')}`}
        />
      </Box>
    </>
  );
};
